export const emptyProfile = {
  name: "",
  email: "",
  mobile: "",
  company: "",
};

export const mapCustomerProfile = (data) => {
  if (!data || typeof data !== "object") {
    return null;
  }

  const profile = {
    name: data.name || data.customer_name || "",
    email: data.email_id || "",
    mobile: data.mobile_no != null ? String(data.mobile_no) : "",
    company: data.company_name || "",
  };

  if (!profile.name && !profile.email && !profile.mobile && !profile.company) {
    return null;
  }

  return profile;
};

export const mapDealerProfile = (data) => {
  if (!data || typeof data !== "object") {
    return null;
  }

  // Device list rows expose the customer's company_name, not the dealer's.
  const isDeviceRow =
    data.dealer_name != null ||
    data.dealer_email != null ||
    data.dealer_mobile != null;

  const profile = {
    name: data.name || data.dealer_name || "",
    email: data.email_id || data.dealer_email || "",
    mobile:
      data.mobile_no != null
        ? String(data.mobile_no)
        : data.dealer_mobile != null
          ? String(data.dealer_mobile)
          : "",
    company: isDeviceRow ? "" : data.company_name || "",
  };

  if (!profile.name && !profile.email && !profile.mobile && !profile.company) {
    return null;
  }

  return profile;
};

const readStoredUser = (mapProfile) => {
  try {
    const stored = localStorage.getItem("user");
    return stored ? mapProfile(JSON.parse(stored)) : null;
  } catch (error) {
    return null;
  }
};

export const loadCustomerProfile = async (client) => {
  try {
    const response = await client.post("view/devices");
    const profile = mapCustomerProfile(response?.data?.[0]);
    if (profile) {
      return profile;
    }
  } catch (error) {
    // Use the user object saved at login when the device list is empty or fails
  }

  return readStoredUser(mapCustomerProfile);
};

export const loadDealerProfile = async (client) => {
  let deviceProfile = null;

  try {
    const response = await client.post("view/devices/dealer");
    deviceProfile = mapDealerProfile(response?.data?.[0]);
  } catch (error) {
    // Dealer device list may be empty; company name still comes from login
  }

  const storedProfile = readStoredUser(mapDealerProfile);

  if (!deviceProfile && !storedProfile) {
    return null;
  }

  return {
    ...emptyProfile,
    ...storedProfile,
    ...deviceProfile,
    company: deviceProfile?.company || storedProfile?.company || "",
  };
};
